module.exports = __webpack_public_path__ + "img/check-blue.c53b5ed2.svg";